import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rc2003',
    ecrans: ['00-2'],
    params: ['?txmcleint']
});

